<template>
  <section class="section">
    <div class="container faq__container">
      <div class="section__header section__header--center">
        <span class="section__label">Вопросы и ответы</span>
        <h2 class="section__title">Частые вопросы</h2>
      </div>
      <div class="faq__list">
        <details v-for="item in faq" :key="item.q" class="faq__item">
          <summary class="faq__question">{{ item.q }}</summary>
          <p class="faq__answer">{{ item.a }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqSection',
  data() {
    return {
      faq: [
        {
          q: 'Это безопасно? Куда попадут наши данные?',
          a: 'Для демо достаточно обезличенных данных — без ФИО и персональных данных сотрудников. Доступ к данным компании есть только у вас; по запросу работаем по соглашению о конфиденциальности.',
        },
        {
          q: 'Сколько времени это займёт у нашей команды?',
          a: 'Около двух часов: встреча-разбор и выгрузка примера расчёта из Excel. Настройку формул и импорт данных мы берём на себя.',
        },
        {
          q: 'У нас выплаты идут через 1С. Как вы с ней работаете?',
          a: 'Система формирует расчётную ведомость в Excel/CSV в формате под загрузку в 1С. Прямая интеграция с 1С — в плане развития.',
        },
        {
          q: 'Почему нельзя посчитать премию прямо в 1С или в учётной системе?',
          a: 'Потому что данные для премии лежат в двух разных местах. В 1С — кадры: оклады, ставки, приёмы и увольнения, табель. В учётной системе — выработка: приёмы, услуги, выручка по каждому сотруднику. Считать в 1С — значит регулярно тянуть туда выработку из учётной системы. Считать в учётной системе — тянуть из 1С кадровые данные. В обоих случаях кто-то каждый месяц сводит две выгрузки вручную, и именно на этом сведении возникают ошибки. Мы делаем этот стык рабочим местом: данные из обеих систем сходятся в одном расчёте, а обратно уходит готовая ведомость.',
        },
        {
          q: 'У нас сложные формулы. Точно получится?',
          a: 'Конструктор покрывает типовые схемы премирования: произведение факторов (база × коэффициенты × факт/план), шкалы и ступени, формулы-корректировки со знаком минус (при этом итог части не уходит в минус) и коэффициенты части — например, ручной коэффициент руководителя с заданными границами. Принесите свою самую сложную формулу на встречу — разберём прямо на ней.',
        },
        {
          q: 'Можно ли привязать премию к KPI?',
          a: 'Да. Для сотрудника собирается KPI-карта: каждому показателю — вес и фактический процент выполнения. Итог карты считается как взвешенное среднее (веса можно не сводить к 100% — система нормирует сама) и автоматически подставляется множителем в формулу премии.',
        },
        {
          q: 'Сотрудник видит премию до конца месяца?',
          a: 'Да. В личном кабинете видна онлайн-оценка премии в любой момент периода — она считается по актуальным данным. Официальную сумму для ведомости фиксирует авторитетный серверный расчёт по всей компании; он и попадает в бухгалтерию.',
        },
        {
          q: 'У нас филиалы — как разграничить доступ?',
          a: 'Назначаете руководителя или HR-менеджера на подразделение один раз — доступ каскадом распространяется на всех подчинённых внутри него. Филиал видит только свои данные, без ручной раздачи прав по каждому сотруднику.',
        },
        {
          q: 'Есть мобильная версия и тёмная тема?',
          a: 'Да. Интерфейс адаптивный — премию и KPI можно проверить с телефона или планшета. Доступны светлая и тёмная темы, а вместо системных окон — понятные уведомления-тосты.',
        },
        {
          q: 'Сколько это стоит после демо?',
          a: 'Для первых пилотных компаний — специальные условия: внедрение бесплатно и существенная скидка на подписку на время пилота. Цену зафиксируем в пилотном договоре до старта.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.faq__container { max-width: 760px; }
.faq__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.faq__item {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px 24px;
  transition: var(--transition);
}
.faq__item[open] { box-shadow: var(--shadow); }
.faq__question {
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--dark);
  cursor: pointer;
  list-style: none;
  position: relative;
  padding-right: 32px;
}
.faq__question::-webkit-details-marker { display: none; }
.faq__question::after {
  content: '+';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--primary);
}
.faq__item[open] .faq__question::after { content: '−'; }
.faq__answer {
  margin-top: 12px;
  color: var(--gray);
  font-size: 0.9375rem;
  line-height: 1.7;
}
</style>
